<template>
  <div class="text-chip-button">
    <div class="text-chip-button_text">
      <WsTextChip001 thin iconXl :red="red" :textLabel="chipText" :leadingIcon="chipIcon" />
    </div>
    <WsButton001 :disable="disable" :isloading="isLoading" @click="$_buttonOnclick()">
      {{ $t(button) }}
    </WsButton001>
  </div>
</template>
<script>
export default {
  name: 'TextChipButton',
  props: {
    button: {
      type: String,
      default: '',
    },
    chipText: {
      type: String,
      default: '',
    },
    chipIcon: {
      type: String,
      default: '',
    },
    red: {
      type: Boolean,
      default: false,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    $_buttonOnclick() {
      this.$emit('click');
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/component/text-chip-button';
</style>
